import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, switchMap, take } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { AssetGroupService } from "./asset-group.service";

export interface AssetFilter {
  groups: number[];
}

@Injectable({ providedIn: "root" })
export class AssetFilterService {
  private readonly http = inject(HttpClient);
  private readonly assetGroups = inject(AssetGroupService);

  private readonly url = `${environment.apiServerUrl}/asset/filter`;

  get(): Observable<AssetFilter> {
    return this.http.get<AssetFilter>(this.url).pipe(
      switchMap((filter) => this.withAccessibleGroupsOnly(filter)),
    );
  }

  set(groups: number[]): Observable<AssetFilter> {
    return this.http.put<AssetFilter>(this.url, { groups }).pipe(
      switchMap((filter) => this.withAccessibleGroupsOnly(filter)),
    );
  }

  // The backend stores group ids without an ownership check, so a saved filter
  // can reference groups the user has lost access to since.
  private withAccessibleGroupsOnly(filter: AssetFilter): Observable<AssetFilter> {
    return this.assetGroups.all.pipe(
      take(1),
      map((groups) => new Set(groups.map(({ id }) => id))),
      map((accessibleIds) => ({
        ...filter,
        groups: filter.groups.filter((id) => accessibleIds.has(id)),
      })),
    );
  }
}
